import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'


export default function ListUsers() {
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);

    // Load users
    useEffect(() => {
        console.log("loading users...");
        console.log("currentUser", user)
       
            axios
              .get(`https://${process.env.REACT_APP_IP}/api/users/`, {
                  headers: { Authorization: `bearer ${user.token}` },
              })
              .then((res) => {
                console.log("Users:", res.data);
                setUsers(res.data);
                setLoading(false);
              })
              .catch((err) => {
                console.log(err);
                setLoading(false);
              });
          
    }, []);



    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        {user.role == "Admin" && (
                            <>
                            <h1>Users  /Agents <button className="btn-sm btn-primary" onClick={() => { navigate(`/Users/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                            <table style={{width: "100%"}}>
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Name</th>
                                        <th>Agent No.</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users && (users.map((user) => {
                                        return (
                                            <tr key={user.id} style={{ cursor: "pointer" }}>
                                                <td><img src={user.profileImage && user.profileImage} height="25" style={{borderRadius:2}} /></td>
                                                <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.agentNumber}</td>
                                                <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.name}</td>
                                                <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.email}</td>
                                                <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.role}</td>
                                                <td>
                                                    <Link to={`/Users/View/${user.id}`} className="btn-sm btn-primary">View</Link>
                                                    <Link to={`/Users/Edit/${user.id}`} className="btn-sm btn-other">Edit</Link>
                                                </td>
                                            </tr>
                                        )
                                    }))}
                            
                                </tbody>
                            </table>
                            </>
                            )}
                            {user.role != "Admin" && (
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h1>Forbidden</h1>
                                            <p>You do not have permission to view users.</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
